/* eslint-disable */
import React, { useState } from "react"
import { useForm, Controller } from 'react-hook-form';
import TextField from '../TextFieldCustom';
import Select from '../Select';
import Button from '../Button';
import { useSubmitForm } from '../../hooks/hook.submit-form';

import provinceItaliane from '../../assets/province-italiane.json';
import FormMuseiBiblioteche from "./form.musei-biblioteche"

const FormOspedaliAmici = ({ setShowThankYouPage, disclaimer }) => {
  const {
    handleSubmit,
    register,
    errors,
    control
  } = useForm({
    mode: 'onFocus'
  });

  const [loadingOnSubmit, setLoadingOnSubmit] = useState({
    label: 'Invia',
    disabled: false
  });

  const onSubmit = (data) => {
    setLoadingOnSubmit({
        label: 'Sto Inviando',
        disabled: true
      }
    );
    useSubmitForm(
      data,
      318,
      () => setShowThankYouPage(true),
      () => {
        setLoadingOnSubmit({
            label: 'Invia',
            disabled: false
          }
        );
        alert('Ops, errore di rete, ritenta l\'invio');
      }
    );
  };

  return (
    <form noValidate className="form-group" onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group__container">
        <h3 className="form-group__title heading-md">Ospedali Amici dei Bambini</h3>

        {/** NAME */}
        <TextField
          className="form-group__textfield"
          type="text"
          name="Nome"
          label="Nome"
          error={errors['Nome'] ? errors['Nome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il nome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** SURNAME */}
        <TextField
          className="form-group__textfield"
          type="text"
          label="Cognome"
          name="Cognome"
          error={errors['Cognome'] ? errors['Cognome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il cognome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** QUALIFICATION */}
        <TextField
          type="text"
          name="Qualifica"
          label="Qualifica"
          error={errors['Qualifica'] ? errors['Qualifica'].message : ''}
          className="form-group__textfield"
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'La qualifica deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** DEPARTMENT */}
        <TextField
          type="text"
          name="Reparto o servizio di appartenenza"
          label="Reparto o servizio di appartenenza"
          className="form-group__textfield"
          error={errors['Reparto o servizio di appartenenza'] ? errors['Reparto o servizio di appartenenza'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          label="Telefono"
          name="Telefono"
          required
          className="form-group__textfield"
          error={errors['Telefono'] ? errors['Telefono'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** EMAIL */}
        <TextField
          className="form-group__textfield"
          type="text"
          label="Email"
          name="Email"
          required
          error={errors['Email'] ? errors['Email'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Formato email non valido'
            }
          })}
        />

        <h4 className="form-group__subtitle heading-md">Dati del punto nascita</h4>
        {/** DENOMINATION */}
        <TextField
          type="text"
          name="Denominazione_pn"
          label="Denominazione"
          className="form-group__textfield"
          error={errors['Denominazione_pn'] ? errors['Denominazione_pn'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** ADDRESS */}
        <TextField
          type="text"
          name="Indirizzo_pn"
          label="Indirizzo (compreso numero civico)"
          error={errors['Indirizzo_pn'] ? errors['Indirizzo_pn'].message : ''}
          className="form-group__textfield"
          required
          inputRef={register({
            required: 'Campo obbligatorio',
          })}
        />

        {/** CAP */}
        <TextField
          type="text"
          name="Cap_pn"
          label="CAP"
          className="form-group__textfield"
          error={errors['Cap_pn'] ? errors['Cap_pn'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          label="Telefono"
          name="Telefono_pn"
          required
          className="form-group__textfield"
          error={errors['Telefono_pn'] ? errors['Telefono_pn'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** CITY */}
        <TextField
          type="text"
          name="Citta_pn"
          label="Città"
          className="form-group__textfield"
          error={errors['Citta_pn'] ? errors['Citta_pn'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** PROVINCE */}
        <Controller
          control={control}
          name="Provincia_pn"
          rules={{ required: 'Campo obbligatorio' }}
          render={({ onChange }) => (
            <Select
              required
              className="form-group__select"
              label="Provincia"
              name="Provincia_pn"
              error={errors['Provincia_pn'] ? errors['Provincia_pn'].message : ''}
              options={provinceItaliane}
              handleChange={(value) => onChange(value)}
              inputRef={register({
                required: 'Campo obbligatorio'
              })}
            />
          )}
        />

        {/** MUNICIPALITY */}
        <TextField
          type="text"
          name="Comune_pn"
          label="Comune"
          className="form-group__textfield"
          required
          error={errors['Comune_pn'] ? errors['Comune_pn'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** WEBSITE */}
        <TextField
          type="text"
          name="Sito Web_pn"
          label="Sito Web"
          className="form-group__textfield"
          inputRef={register()}
        />

        <h4 className="form-group__subtitle heading-md">Dati dell'azienda sanitaria</h4>
        {/** DENOMINATION */}
        <TextField
          type="text"
          name="Denominazione_as"
          label="Denominazione"
          className="form-group__textfield"
          required
          error={errors['Denominazione_as'] ? errors['Denominazione_as'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** ADDRESS */}
        <TextField
          type="text"
          name="Indirizzo_as"
          label="Indirizzo (compreso numero civico)"
          className="form-group__textfield"
          required
          error={errors['Indirizzo_as'] ? errors['Indirizzo_as'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** CAP */}
        <TextField
          type="text"
          name="Cap_as"
          label="CAP"
          className="form-group__textfield"
          required
          error={errors['Cap_as'] ? errors['Cap_as'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          label="Telefono"
          name="Telefono_as"
          required
          className="form-group__textfield"
          error={errors['Telefono_as'] ? errors['Telefono_as'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** CITY */}
        <TextField
          type="text"
          name="Citta_as"
          label="Città"
          className="form-group__textfield"
          required
          error={errors['Citta_as'] ? errors['Citta_as'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** PROVINCE */}
        <Controller
          control={control}
          name="Provincia_as"
          rules={{ required: 'Campo obbligatorio' }}
          render={({ onChange }) => (
            <Select
              required
              className="form-group__select"
              label="Provincia"
              name="Provincia_as"
              error={errors['Provincia_pn'] ? errors['Provincia_pn'].message : ''}
              options={provinceItaliane}
              handleChange={(value) => onChange(value)}
              inputRef={register({
                required: 'Campo obbligatorio'
              })}
            />
          )}
        />

        {/** MUNICIPALITY */}
        <TextField
          type="text"
          name="Comune_as"
          label="Comune"
          className="form-group__textfield"
          required
          error={errors['Comune_as'] ? errors['Comune_as'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** WEBSITE */}
        <TextField
          type="text"
          name="Sito Web_as"
          label="Sito Web"
          className="form-group__textfield"
          inputRef={register()}
        />

        {/** DIRECTOR'S EMAIL */}
        <TextField
          type="text"
          name="E-mail direttore generale"
          label="Email Direttore generale"
          className="form-group__textfield"
          required
          error={errors['E-mail direttore generale'] ? errors['E-mail direttore generale'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Formato email non valido'
            }
          })}
        />

        {/** PRIVACY POLICY */}
        <div className="paragraph-small" dangerouslySetInnerHTML={{__html: disclaimer}} />
        <div className="form-group__privacy">
          {/** SUBMIT BUTTON */}
          <Button type="submit" kind="primary" disabled={loadingOnSubmit.disabled} label={loadingOnSubmit.label} color="brand" />
        </div>
      </div>
    </form>
  );
};

FormOspedaliAmici.defaultProps = {
  disclaimer:
    '          <strong>Informativa ex art.13, GDPR</strong>\n' +
    '\n' +
    '          <p>Titolare del trattamento dei dati è il Comitato Italiano per l’UNICEF - Fondazione ONLUS , Via Palestro 68, 00185 Roma (RM).\n' +
    '            I dati personali saranno trattati con modalità prevalentemente elettroniche per le seguenti finalità:</p>\n' +
    '          <ul>\n' +
    '            <li>a) Inviare il materiale richiesto e/o dare riscontro alle richieste avanzate per l’adesione al Percorso di interesse</li>\n' +
    '            <li>b) Ottemperare a norme di legge o regolamento</li>\n' +
    '            <li>c) Fornire informazioni su iniziative/programmi di sensibilizzazione e promozione dei diritti dei bambini</li>\n' +
    '          </ul>\n' +
    '          <p>Per le finalità ai punti a) e b), il trattamento dei dati è ammesso senza il consenso dell’interessato ai sensi dell’art. 6 comma 1, lett. b) e c)\n' +
    '            GDPR; i dati saranno conservati per il tempo necessario a rispondere alle richieste e per eventuali contatti di approfondimento che permettano di\n' +
    '            valutare se aderire all’ iniziativa di interesse; in ogni caso per il periodo consentito dalla legge per esigenze di tutela legale. Per le finalità al\n' +
    '            punto c) il trattamento è ammesso ai sensi dell’art. 6 comma 1 lettera f) GDPR (“legittimo interesse”); i dati verranno conservati per il periodo\n' +
    '            consentito dalla legge per esigenze di tutela legale; la conservazione può essere di tempo inferiore se non si ha più\n' +
    '            interesse ad essere informati e lo si comunica con le modalità sotto riportate.</p>\n' +
    '          <p>Per i predetti fini saranno conservati anche successivamente, laddove leggi, regolamenti o normativa comunitaria ne determinino\n' +
    '            la conservazione per tempi differenti. Inoltre, saranno conservati in caso di imposizione da parte delle Forze dell’Ordine,\n' +
    '            della Magistratura e Organi di Controllo e per far valere o difendere diritti in sede giudiziaria. Le persone autorizzate al trattamento sono\n' +
    '            gli addetti all’amministrazione e organizzatori dell’iniziativa, alle attività istituzionali e statutarie, dei sistemi informativi e di sicurezza dei dati.</p>\n' +
    '          <p>Ai sensi degli artt. 15-22, GDPR, scrivendo all’e-mail <a href="mailto:infoprivacy@unicef.it">infoprivacy@unicef.it</a>,\n' +
    '            si può richiedere l’elenco completo e aggiornato dei responsabili del trattamento, nonché esercitare i diritti di consultazione,\n' +
    '            modificazione, di cancellazione e oblio, limitazione del trattamento dei dati, portabilità dei dati o opporsi al loro trattamento. Inoltre,\n' +
    '            l’interessato ha diritto di presentare reclamo all’autorità di controllo – per l’Italia è il Garante per la protezione dei dati personali\n' +
    '            – <a href="https://www.garanteprivacy.it">www.garanteprivacy.it</a>, per far valere i propri diritti. Il Data Protection Officer\n' +
    '            è contattabile all’e-mail <a href="mailto:dpo@unicef.it">dpo@unicef.it</a>, per informazioni sul trattamento dei dati.</p>\n' +
    '\n' +
    '          Informativa completa al sito <a href="https://www.unicef.it/note-sulla-privacy">www.unicef.it/privacy</a>\n'
}

export default FormOspedaliAmici;
